export type WorkspaceTourSection = 'dashboard' | 'data' | 'employees' | 'ai-assistant';

export type WorkspaceTourPrepare = 'market-filters' | 'employees-list';

export type WorkspaceTourStep = {
  id: string;
  section: WorkspaceTourSection;
  target: string;
  title: string;
  body: string;
  placement: 'right' | 'bottom' | 'left' | 'top';
  optionalIfNoAi?: boolean;
  prepare?: WorkspaceTourPrepare;
};

export const WORKSPACE_TOUR_NARROW_MAX_WIDTH = 980;

export const WORKSPACE_TOUR_STEPS: WorkspaceTourStep[] = [
  {
    id: 'welcome',
    section: 'dashboard',
    target: 'nav-home',
    title: 'Добро пожаловать в datacircle',
    body: 'Здесь ваш рабочий кабинет: рыночные ориентиры по компенсациям, сравнение вашей команды с рынком и AI-помощник. Пройдём ключевые разделы за пару минут.',
    placement: 'right',
  },
  {
    id: 'dash-stats',
    section: 'dashboard',
    target: 'dash-stats',
    title: 'Сводка по кабинету',
    body: 'Сверху — что уже доступно по подписке: наборы данных и организации. Это не рынок целиком, а ваш контур доступа.',
    placement: 'bottom',
  },
  {
    id: 'dash-tools',
    section: 'dashboard',
    target: 'dash-tools',
    title: 'Три рабочих инструмента',
    body: 'Дальше почти вся работа идёт через три раздела: обзор рынка, сотрудники и AI-ассистент. Открыть их можно отсюда или из меню слева.',
    placement: 'bottom',
  },
  {
    id: 'nav-market',
    section: 'dashboard',
    target: 'nav-market',
    title: 'Обзор рынка',
    body: 'Переходим сюда, когда нужно понять рыночный уровень FIX, STI и total compensation по ролям.',
    placement: 'right',
  },
  {
    id: 'market-industry',
    section: 'data',
    target: 'market-industry',
    title: 'Сначала выберите индустрию',
    body: 'Пакет рынка задаёт выборку. Доступны только индустрии из вашей подписки — без чужих данных.',
    placement: 'bottom',
  },
  {
    id: 'market-filters',
    section: 'data',
    target: 'market-filters',
    title: 'Сузьте выборку',
    body: 'Фильтры по секторам или компаниям, надёжности, AUM и численности. Чем уже группа, тем точнее картина — и тем строже порог, чтобы показать перцентили.',
    placement: 'bottom',
    prepare: 'market-filters',
  },
  {
    id: 'market-availability',
    section: 'data',
    target: 'market-availability',
    title: 'Почему часть цифр скрыта',
    body: 'Блок «Доступность данных» показывает, для скольких ролей хватает выборки на среднее, медиану и крайние перцентили. Прочерки — защита анонимности, а не ошибка.',
    placement: 'top',
  },
  {
    id: 'nav-employees',
    section: 'data',
    target: 'nav-employees',
    title: 'Мои сотрудники',
    body: 'Сюда заносят вашу команду. Данные остаются на устройстве и на сервер datacircle не уходят.',
    placement: 'right',
  },
  {
    id: 'employees-form',
    section: 'employees',
    target: 'employees-form',
    title: 'Добавьте людей и пакет',
    body: 'Укажите должность, FIX, STI и LTIP. Это база для сравнения с рынком по тем же правилам, что в обзоре.',
    placement: 'bottom',
    prepare: 'employees-list',
  },
  {
    id: 'employees-tabs',
    section: 'employees',
    target: 'employees-tabs',
    title: 'Сначала грейд, потом сравнение',
    body: 'Вкладка «Грейдирование» ставит рыночный эквивалент роли. Без него сравнение с перцентилями будет неточным.',
    placement: 'bottom',
    prepare: 'employees-list',
  },
  {
    id: 'nav-ai',
    section: 'employees',
    target: 'nav-ai',
    title: 'AI-ассистент',
    body: 'Вопросы по компенсациям на данных вашей подписки и сотрудников из локального кэша. Лимит запросов зависит от тарифа.',
    placement: 'right',
    optionalIfNoAi: true,
  },
  {
    id: 'ai-prompts',
    section: 'ai-assistant',
    target: 'ai-prompts',
    title: 'Готовые вопросы',
    body: 'Три шаблона — быстрый старт. Формулируйте конкретнее: роль, уровень, FIX/STI — так ответ ближе к вашей задаче.',
    placement: 'bottom',
    optionalIfNoAi: true,
  },
  {
    id: 'sidebar-profile',
    section: 'dashboard',
    target: 'sidebar-profile',
    title: 'Можно пройти ещё раз',
    body: 'Тур больше сам не откроется. Если понадобится — нажмите «Подсказки» рядом с профилем внизу меню.',
    placement: 'right',
  },
];

export function filterWorkspaceTourSteps(includeAi: boolean): WorkspaceTourStep[] {
  if (includeAi) return WORKSPACE_TOUR_STEPS;
  return WORKSPACE_TOUR_STEPS.filter((step) => !step.optionalIfNoAi);
}
